document.addEventListener('DOMContentLoaded', function(){
  const stainGuideForm = document.querySelector('.stain-guide-form')
  if (stainGuideForm) {
    stainGuideForm.addEventListener('submit', function(e){
      e.preventDefault();
      const materialInput = document.querySelector('#value_3')
      const stainTypeInput = document.querySelector('#value_1')
      const errorMessage = document.querySelector(".stain-guide__error-message")

      if (!materialInput || !stainTypeInput) return;

      var material = materialInput.value.toLowerCase()
      var stainType = stainTypeInput.value.toLowerCase()

      var searchQuery = encodeURIComponent(stainTypeInput.value);
      var searchUrl = `/search/suggest.json?q=${searchQuery}&resources[type]=article&resources[limit]=1&resources[options][fields]=tag`;
      var searchpage = `/search?q=${searchQuery}&type=article`

      if (errorMessage) {
        errorMessage.style.display = 'none';
      }
      if (stainTypeInput) {
        stainTypeInput.style.borderColor = '';
      }

      if (stainType === "") {
        if (errorMessage) {
          errorMessage.style.display = 'block';
        }
        if (stainTypeInput) {
          stainTypeInput.style.borderColor = 'red';
        }
        return
      }

      if (material.includes('silk') || material.includes('viscose') || material.includes('lace') ){
        window.location = '/blogs/tips/how-to-stain-guide-delicate-stain-guide';
        return
      }

      if (material.includes('cashmere') || material.includes('wool') || material.includes('merino') || material.includes('mohair')){
        window.location = '/blogs/tips/how-to-stain-guide-knitwear-stain-guide';
        return
      }

      if (material.includes('fur') || material.includes('suede') || material.includes('leather')){
        window.location = '/blogs/tips/how-to-stain-guide-dry-clean-stain-guide';
        return
      }

     if (searchQuery === '') {
          window.location = '/blogs/tips/how-to-stain-guide-general';
      } else {
        fetch(searchUrl)
          .then(response => response.json())
          .then(res => {
            if(res.resources.results.articles.length > 0) {
              window.location = res.resources.results.articles[0].url
            } else {
              window.location = '/blogs/tips/how-to-stain-guide-general';
            }
          })
          .catch(error => {
            console.error('Error fetching search results:', error);
            window.location = '/blogs/tips/how-to-stain-guide-general';
          })
      }
    })
  }
})
